import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const handlePacienteSubmit = async ({
  e,
  owner,
  patient,
  token,
  setMessage,
  setOwner,
  setPatient,
}) => {
  e.preventDefault();
  setMessage("");

  try {
    // 1. Armar objeto user con owner.mail y owner.full_name
    const user = {
      username: owner.mail,
      mail: owner.mail,
      full_name: owner.full_name,
      password: "temporal123", // Puedes ajustar la lógica de password si es necesario
      profile_id: 4, // Ajusta el perfil según tu lógica de negocio
    };

    // 2. Crear usuario (JSON)
    const userRes = await axios.post(
      `${API_URL}/users`,
      user,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const user_id = userRes.data.id;
    console.log("Usuario creado:", userRes);
    console.log("Usuario creado:", user_id);

    // 3. Crear owner (formData)
    const ownerFormData = new FormData();
    const { photo: ownerPhoto, ...ownerRest } = owner;
    ownerFormData.append("user_id", user_id);
    ownerFormData.append("full_name", ownerRest.full_name);
    ownerFormData.append("rut", ownerRest.rut);
    ownerFormData.append("phone", ownerRest.phone);
    ownerFormData.append("address", ownerRest.address);
    if (ownerPhoto) ownerFormData.append("photo", ownerPhoto);

    const ownerRes = await axios.post(
      `${API_URL}/patients/owners`,
      ownerFormData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const owner_id = ownerRes.data.id;

    // 4. Crear paciente (formData)
    const patientFormData = new FormData();
    const { photo: patientPhoto, ...patientRest } = patient;
    patientFormData.append("owner_id", owner_id);
    patientFormData.append("name", patientRest.name);
    patientFormData.append("species", patientRest.species);
    patientFormData.append("breed", patientRest.breed);
    patientFormData.append("age", patientRest.age);
    patientFormData.append("chip", patientRest.chip);
    if (patientPhoto) patientFormData.append("photo", patientPhoto);

    await axios.post(
      `${API_URL}/patients`,
      patientFormData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setMessage("Paciente registrado correctamente.");
    setOwner({
      full_name: "",
      rut: "",
      mail: "",
      phone: "",
      address: "",
      photo: "",
    });
    setPatient({
      name: "",
      species: "",
      breed: "",
      age: "",
      chip: "",
      photo: "",
    });
  } catch (err) {
    setMessage("Error al registrar paciente.");
  }
};

export const fetchPacientes = async (token, setPacientes, setLoading) => {
  setLoading(true);
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/patients`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    setPacientes(res.data);
  } catch {
    setPacientes([]);
  } finally {
    setLoading(false);
  }
};

export const fetchOwners = async (token, setOwners) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/patients/owners`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    setOwners(res.data);
  } catch {
    setOwners([]);
  }
};

export const getOwnerName = (owners, owner_id) => {
  const owner = owners.find((o) => o.id === owner_id);
  return owner ? owner.full_name : "";
};